import { render, staticRenderFns } from "./SearchResultItems.vue?vue&type=template&id=390e67c2&scoped=true&"
import script from "./SearchResultItems.vue?vue&type=script&lang=js&"
export * from "./SearchResultItems.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultItems.vue?vue&type=style&index=0&id=390e67c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390e67c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
